import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import PropTypes from "prop-types";
import { extendedSystemStylesProps } from "@mixins";
import { StyledFieldset, FieldsetLegend, styledSystemKeys } from "./fieldset.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Fieldset = function Fieldset(props) {
  var legend = props.legend,
    hideLegend = props.hideLegend,
    icon = props.icon,
    className = props.className,
    children = props.children;
  return /*#__PURE__*/_jsxs(StyledFieldset, _objectSpread(_objectSpread({
    className: className
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    children: [/*#__PURE__*/_jsx(FieldsetLegend, {
      hideLegend: hideLegend,
      icon: icon,
      children: legend
    }), children]
  }));
};
Fieldset.propTypes = {
  legend: PropTypes.any.isRequired,
  children: PropTypes.any.isRequired,
  hideLegend: PropTypes.oneOf([true, false]),
  icon: PropTypes.string,
  className: PropTypes.string
};
export default Fieldset;